export interface TransferSelectedBasketPayload {
  recipient: number
  shop_id: number
  basket_id: string
}

export class TransferSelectedBasketRequest{
  endpointUrl: URL
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }
  data: TransferSelectedBasketPayload

  constructor(endpoint: string, recipient: number, shopId: number, basketId: string) {
    this.endpointUrl = new URL(endpoint + 'TransferSelectedBasket/', window.location.href)
    this.data = {
      recipient: recipient,
      shop_id: shopId,
      basket_id: basketId
    }
  }
}
